import React from 'react';
import WooDriver from './WooDriver';
import AppContainer from '../AppContainer';

export const WooAppBridgeWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <WooDriver>
      <AppContainer>{children}</AppContainer>
    </WooDriver>
  );
};
